// extracted by mini-css-extract-plugin
export default {"text_gradient":"GradientText_text_gradient__kHHH9"};